(function ($) {
  Drupal.behaviors.shoppableAdV1 = {
    attach: function (context, settings) {
      $('.shoppable-ad-v1').each(function () {
        var $me = $(this);
        var topPadding = $me.css('padding-top');

        $me
          .find('img.shoppable-image')
          .css('margin-top', '-' + topPadding + 'px');

        // Set up hotspots
        $me.find('.sa-product').each(function (i) {
          $(this)
            .find('.marker')
            .attr('item', 'item-' + i)
            .siblings('#quickshop')
            .attr('item', 'item-' + i);
        });
      });
    }
  };
})(jQuery);
